import { useMediaQuery } from '@mui/material';

export const useIsSmallMobile = () => {
  return useMediaQuery('(max-width:370px)');
};
